import { FC, useCallback } from 'react';
import { useSnapshot } from 'valtio';
import { createApiKey } from '../actions/create-api-key-actions';
import CreateApiKeyModal from '../components/CreateApiKeyModal';
import { closeCreateApiKeyModal } from '../store-actions/create-api-key-store-actions';
import CreateApiKeysStore from '../stores/create-api-key-store';
import { ApiKeyRoleType, CreateApiKeyInput } from '../types/api-key-types';

const CreateApiKeyContainer: FC<
  React.PropsWithChildren<CreateApiKeyContainerProps>
> = ({ apiKeyRoleTypes }) => {
  const { isModalVisible, isLoading, errorMessage, keySecret } =
    useSnapshot(CreateApiKeysStore);

  const onCreate = useCallback(async (createApiKeyInput: CreateApiKeyInput) => {
    await createApiKey(createApiKeyInput);
  }, []);

  if (!isModalVisible) {
    return null;
  }

  return (
    <CreateApiKeyModal
      open={isModalVisible}
      onClose={closeCreateApiKeyModal}
      onCreateApiKey={onCreate}
      apiKeyRoleTypes={apiKeyRoleTypes}
      isInviteButtonLoading={isLoading}
      errorMessage={errorMessage}
      keySecret={keySecret}
    />
  );
};

export interface CreateApiKeyContainerProps {
  apiKeyRoleTypes: ApiKeyRoleType[];
}

export default CreateApiKeyContainer;
